<template>
  <div>
    <div class="quote">
      <h3 class="smallmarginbottom"></h3>
    </div>
    <h3></h3>

    <h3 class="">What is service design?</h3>
    <p>
      In short: <em>we design the whole experience</em> — the visible parts people use and the invisible systems that make it work.
    </p>

    <h3 class="">E2E design process</h3>
    <p>
      Developing services and design systems. Instrumental at all stages, from strategy to delivery.
    </p>
    <p>
      Think of a service like a journey through a theme park. It's not only the rides. It's the signs that guide you, the app that shows queue times, the staff who help, the safety checks you don't see, and even how you pay and leave. Service design makes all those pieces click — so visitors have a great time and the park runs smoothly behind the scenes.
    </p>

    <figure>
      <img
        class="invertedColour"
        src="@/assets/images/EY/workshop_1.jpg"
        alt="Client co-creation workshop"
      />
      <figcaption>
        A service design engagement can range from a short two-week project,
        such as mapping service pain points with a local council, to a year-long
        initiative, such as creating a new service from the ground up for a
        large international financial institution.
      </figcaption>
    </figure>

    <!-- <p class="smallmarginbottom">
      <small> Industries:</small>
    </p>
    <div class="inlineBlock">
      <div class="tag">Finance</div>
      <div class="tag">Wealth management</div>
      <div class="tag">Banking</div>
      <div class="tag">Renewable energies</div>
      <div class="tag">Retail analytics</div>
      <div class="tag">Genomics</div>
      <div class="tag">Education</div>
      <div class="tag">Blockchain</div>
    </div> -->

    <div class="notification alert" role="note">
      <p class="nomargintopbottom">
        The design materials displayed below are intentionally modified or
        presented in low resolution to safeguard client confidentiality and
        competitive advantage.
      </p>
    </div>

    <p>
      Service design work often revolves around a service blueprint that links
      user interactions to the operational work behind the scenes. Depending on
      the team's size and the project's scope, my work may involve both hands-on
      tasks and strategic contributions.
    </p>

    <figure>
      <img
        class="invertedColour"
        src="@/assets/images/EY/client_proto.png"
        alt="Prototype and service blueprint"
      />
      <figcaption>Prototype (above) and service blueprint (below)</figcaption>
    </figure>

    <!-- <figure>
      <img
        class="invertedColour"
        src="@/assets/images/EY/client_proto_2.png"
        alt=">High fidelity prototyping of desktop application"
      />
      <figcaption>High fidelity prototyping of desktop application</figcaption>
    </figure> -->
    <!-- <figure>
      <img
        class="invertedColour"
        src="@/assets/images/EY/client_proto_6.png"
        alt=">High fidelity prototyping of desktop application"
      />
      <figcaption>High fidelity prototyping of desktop application</figcaption>
    </figure> -->

    <!-- <div class="row spaceBetween">
      <figure>
        <img
          class="invertedColour"
          src="@/assets/images/EY/client_proto_3.png"
          alt="High fidelity prototyping of mobile application"
        />
        <figcaption>Mobile examples</figcaption>
      </figure>
      <figure>
        <img
          class="invertedColour"
          src="@/assets/images/EY/client_proto_4.png"
          alt="High fidelity prototyping of mobile application"
        />
        <figcaption></figcaption>
      </figure>
      <figure>
        <img
          class="invertedColour"
          src="@/assets/images/EY/client_proto_5.png"
          alt="High fidelity prototyping of mobile application"
        />
        <figcaption></figcaption>
      </figure>
    </div> -->

    <figure>
      <img
        class="invertedColour"
        src="@/assets/images/EY/workshops.jpg"
        alt="Workshop outcomes summary"
      />
      <figcaption>
        Example of the outcomes of a series of Definition workshops with a
        council
      </figcaption>
    </figure>

    <hr />
    <!-- <h3 class="smallmarginbottom">Beyond corporate work</h3>
    <p>
      Alongside transformation projects for large organisations, I also consult
      on initiatives that demand broader alignment across municipalities,
      universities, and businesses. My role often goes beyond design into
      strategy—helping secure funding, shaping integrated visions, and ensuring
      diverse stakeholders move together.
    </p>
    <p>
      A recent example is the Lavaria project, where I was mandated by the
      Municipality of Fundão to keep a holistic territorial vision at the
      centre. The work spans from re-purposing an abandoned mining site into a
      hub for sustainable design and cultural innovation, to structuring work
      packages for R&amp;D, international residencies, and local engagement.
      This kind of project shows how service design can connect research,
      culture, policy, and market outcomes in ways that extend far beyond
      corporate briefs.
    </p>
    <p>
      Whether in corporate or territorial settings, my work blends strategy,
      design, and development. I align stakeholders, help secure funding, and
      turn abstract ideas into clear operating models. By working closely with
      users, architects, and developers, I make sure vision becomes reality.
    </p>

    <figure>
      <img
        class="invertedColour"
        src="@/assets/images/Patio/lavaria.jpeg"
        alt="Presentation of Lavaria at UBI"
      />
      <figcaption>
        Presentation of Lavaria at UBI, exploring sustainable design and
        cultural innovation for the Cabeço do Pião site.
      </figcaption>
    </figure>

    <figure>
      <img
        class="invertedColour"
        src="@/assets/images/Patio/lavaria_tom.png"
        alt="Target operating model linking research, culture, policy and market outcomes"
      />
      <figcaption>
        Target operating model Phase 2/5: connecting research, culture, and
        policy to pilots, urban requalification, and market adoption.
      </figcaption>
    </figure> -->
  </div>
</template>

<script>
export default {
  name: "ServiceDesignSection",
  props: ["content"],
};
</script>

<style scoped>
.row {
  align-items: flex-start;
  gap: var(--smallerMargin);
}

li {
  text-indent: calc(-1 * var(--regularMargin));
  padding-left: var(--regularMargin);
  display: list-item;
  margin-bottom: var(--smallMargin);
}

/* Explainer button/panel */
.explainer {
  margin-top: var(--regularMargin);
}
.explainerBtn {
  display: inline-block;
  cursor: pointer;
  font: inherit;
}
.explainerBtn:hover {
  background: var(--buttonBgHover, #f0f0f0);
}
.explainerPanel {
  padding: var(--smallMargin);
  border: 1px solid var(--accentColor, #888);
  border-radius: 0.5rem;
}

/* Simple fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 180ms ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
